var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dialog-template', {
    model: {
      value: _vm.isShownContent,
      callback: function callback($$v) {
        _vm.isShownContent = $$v;
      },
      expression: "isShownContent"
    }
  }, [_c('template', {
    slot: "content"
  }, [_c('h4', {
    class: _vm.$style.title
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    class: _vm.$style.content
  }, [_vm._t("default")], 2), _vm._t("footer", [_c('div', {
    class: _vm.$style.button
  }, [_c('simple-button', {
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('dialog.button.clear')) + " ")])], 1)])], 2)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }